import { render, staticRenderFns } from "./ArrivalRecordWin.vue?vue&type=template&id=ba1e86d4"
import script from "./ArrivalRecordWin.vue?vue&type=script&lang=js"
export * from "./ArrivalRecordWin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports